import moment from 'moment'
import React, { useContext, useEffect, useState } from 'react'
import ReactGA from 'react-ga'
import { FaChevronLeft } from 'react-icons/fa'
import { useHistory } from 'react-router-dom'
import { Input, Select } from '../../../components/Form'
import { RootContext } from '../../../context/rootContext'
import { solicitationsOptions } from '../../../utils/constants'

import SolicitationCard from '../../../components/SolicitationCard'
import { getSolicitationsHistory } from '../../../services/solicitations'
import { Container, CustomButton } from '../../../styles/global'
import {
  InputContainer,
  Row,
  SearchButton,
  SolicitationHistoryReadMore,
  Subtitle,
  Title
} from './styles'

const SolicitationsHistory = () => {
  const history = useHistory()
  const { loadingState } = useContext(RootContext)
  const [, setLoading] = loadingState
  const [kind, setKind] = useState('')
  const [dateStart, setDateStart] = useState(moment(new Date()).startOf('month').format('YYYY-MM-DD'))
  const [dateEnd, setDateEnd] = useState(moment(new Date()).endOf('month').format('YYYY-MM-DD'))
  const [solicitationsList, setSolicitationsList] = useState([])
  const [allHistoryLoaded, setAllHistoryLoaded] = useState(false)
  const [pagination, setPagination] = useState({
    skip: 0,
    limit: 5
  })

  useEffect(() => {
    const { skip, limit } = pagination
    getHistory({ kind, skip, limit, dateStart, dateEnd })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination])

  const getHistory = async ({ kind, skip, limit, dateStart, dateEnd, reset = false }) => {
    setLoading(true)
    const { professional: { id: professionalId }, partner } = JSON.parse(localStorage.getItem('userData'))
    const solicitationsHistory = await getSolicitationsHistory({ professionalId, partner, kind, skip, limit, dateStart, dateEnd })

    setSolicitationsList([...(reset ? [] : solicitationsList), ...solicitationsHistory])
    setAllHistoryLoaded(!solicitationsHistory.length)
    setLoading(false)
  }

  const handleBackPage = () => {
    history.push('/solicitations')
    ReactGA.pageview('/solicitations')
  }

  const handleApplyFilter = () => {
    const { limit } = pagination
    getHistory({ kind, skip: 0, limit, dateStart, dateEnd, reset: true })
  }

  const handlePagination = () => {
    setPagination({
      ...pagination,
      skip: solicitationsList.length
    })
  }

  return (
    <Container>
      <Row>
        <Select
          label=''
          options={solicitationsOptions}
          onChange={setKind}
        />
      </Row>

      <Subtitle>Filtrar por período</Subtitle>
      <Row>
        <InputContainer>
          <Input
            type='date'
            label='De'
            value={dateStart}
            onChange={(e) => setDateStart(e.target.value)}
          />
        </InputContainer>

        <InputContainer>
          <Input
            type='date'
            label='Até'
            value={dateEnd}
            onChange={(e) => setDateEnd(e.target.value)}
          />
        </InputContainer>

      </Row>
      <Row>
        <SearchButton onClick={handleApplyFilter}>Filtrar</SearchButton>
      </Row>
      <Title>Histórico</Title>
      {solicitationsList.map(solicitation =>
        <SolicitationCard key={solicitation.id} solicitationData={solicitation} />
      )}
      <SolicitationHistoryReadMore onClick={handlePagination} disabled={allHistoryLoaded}>Ver mais solicitações</SolicitationHistoryReadMore>
      <Row>
        <CustomButton onClick={handleBackPage} outline>
          <FaChevronLeft color='#01878E' size='14' />
          Voltar
        </CustomButton>
      </Row>
    </Container>
  )
}

export default SolicitationsHistory
